// import React from 'react';
// import { AiOutlineClose } from 'react-icons/ai';  // Close icon

// const NextRide = () => {
//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-xl p-6 w-full max-w-md relative">
//         {/* Close Button */}
//         <button
//           className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
//           aria-label="Close"
//         >
//           <AiOutlineClose size={24} />
//         </button>

//         {/* Title */}
//         <h2 className="text-xl font-semibold text-center text-gray-800 mb-6">Search your next ride</h2>

//         {/* Pickup Date & Time */}
//         <div className="mb-4">
//           {/* <label className="text-gray-700 font-medium ">Pickup Date & Time</label> */}
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Pickup Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
             
//               <input
//                 type="date"
//                 placeholder="Date"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
             
//               <input
//                 type="time"
//                 placeholder="Time"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Dropoff Date & Time */}
//         <div className="mb-6">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Dropoff Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
             
//               <input
//                 type="date"
//                 placeholder="Date"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
             
//               <input
//                 type="time"
//                 placeholder="Time"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Search Button */}
//         <button className="w-full bg-amber-600 text-white py-2 rounded-lg font-semibold hover:bg-amber-700">
//           Search
//         </button>
//       </div>
//     </div>
//   );
// };

// export default NextRide;


// import React, { useState } from 'react';
// import { AiOutlineClose } from 'react-icons/ai';  // Close icon

// const NextRide = () => {
//   // State to control the modal visibility
//   const [isOpen, setIsOpen] = useState(true);

//   // Function to close the modal
//   const handleClose = () => {
//     setIsOpen(false);
//   };

//   // Render nothing if the modal is not open
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-xl p-6 w-full max-w-md relative">
//         {/* Close Button */}
//         <button
//           className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
//           aria-label="Close"
//           onClick={handleClose}  // Attach the close function
//         >
//           <AiOutlineClose size={24} />
//         </button>

//         {/* Title */}
//         <h2 className="text-xl font-semibold text-center text-gray-800 mb-6">Search your next ride</h2>

//         {/* Pickup Date & Time */}
//         <div className="mb-4">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Pickup Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="date"
//                 placeholder="Date"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="time"
//                 placeholder="Time"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Dropoff Date & Time */}
//         <div className="mb-6">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Dropoff Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="date"
//                 placeholder="Date"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="time"
//                 placeholder="Time"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Search Button */}
//         <button className="w-full bg-amber-600 text-white py-2 rounded-lg font-semibold hover:bg-amber-700">
//           Search
//         </button>
//       </div>
//     </div>
//   );
// };

// export default NextRide;


// import React, { useState } from 'react';
// import { AiOutlineClose } from 'react-icons/ai';  // Close icon

// const NextRide = () => {
//   // State to control the modal visibility
//   const [isOpen, setIsOpen] = useState(true);

//   // Function to close the modal
//   const handleClose = () => {
//     setIsOpen(false);
//   };

//   // Render nothing if the modal is not open
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-xl p-6 w-full max-w-md relative">
//         {/* Close Button */}
//         <button
//           className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
//           aria-label="Close"
//           onClick={handleClose}  // Attach the close function
//         >
//           <AiOutlineClose size={24} />
//         </button>

//         {/* Title */}
//         <h2 className="text-xl font-semibold text-center text-gray-800 mb-6">Search your next ride</h2>

//         {/* Pickup Date & Time */}
//         <div className="mb-4">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Pickup Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="date"
//                 placeholder="Date"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="time"
//                 placeholder="Time"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Dropoff Date & Time */}
//         <div className="mb-6">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Dropoff Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="date"
//                 placeholder="Date"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="time"
//                 placeholder="Time"
//                 className="w-full focus:outline-none"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Search Button */}
//         <button className="w-full bg-amber-600 text-white py-2 rounded-lg font-semibold hover:bg-amber-700">
//           Search
//         </button>
//       </div>
//     </div>
//   );
// };

// export default NextRide;


// import React from 'react';
// import { AiOutlineClose } from 'react-icons/ai';

// const NextRide = ({ onClose }) => {
//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-xl p-6 w-full max-w-md relative">
//         <button
//           className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
//           aria-label="Close"
//           onClick={onClose} // Call the close function from props
//         >
//           <AiOutlineClose size={24} />
//         </button>

//         <h2 className="text-xl font-semibold text-center text-gray-800 mb-6">
//           Search your next ride
//         </h2>

//         {/* Pickup Date & Time */}
//         <div className="mb-4">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Pickup Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input type="date" className="w-full focus:outline-none" />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input type="time" className="w-full focus:outline-none" />
//             </div>
//           </div>
//         </div>

//         {/* Dropoff Date & Time */}
//         <div className="mb-6">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Dropoff Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input type="date" className="w-full focus:outline-none" />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input type="time" className="w-full focus:outline-none" />
//             </div>
//           </div>
//         </div>

//         <button className="w-full bg-amber-600 text-white py-2 rounded-lg font-semibold hover:bg-amber-700">
//           Search
//         </button>
//       </div>
//     </div>
//   );
// };

// export default NextRide;

// import React from "react";
// import { AiOutlineClose } from "react-icons/ai";

// const NextRide = ({ onClose }) => {
//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-xl p-6 w-full h-auto max-w-lg relative">
//         <button
//           className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
//           aria-label="Close"
//           onClick={onClose}
//         >
//           <AiOutlineClose size={24} />
//         </button>

//         <h2 className="text-xl font-semibold text-center text-gray-800 mb-6">
//           Search your next ride
//         </h2>

//         {/* Pickup Date & Time */}
//         <div className="mb-4">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Pickup Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
              
//               <input
//                 type="date"
//                 placeholder="Date"
//                 className="w-full focus:outline-none placeholder-gray-400"
//               />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
             
//               <input
//                 type="time"
//                 placeholder="Time"
//                 className="w-full focus:outline-none placeholder-gray-400"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Dropoff Date & Time */}
//         <div className="mb-6">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Dropoff Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
          
//               <input
//                 type="date"
//                 placeholder="Date"
//                 className="w-full focus:outline-none placeholder-gray-400"
//               />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="time"
//                 placeholder="Time"
//                 className="w-full focus:outline-none placeholder-gray-400"
//               />
//             </div>
//           </div>
//         </div>

//         <button className="w-full bg-[#FF9630] text-white py-2 rounded-lg font-semibold hover:bg-[#FF9630]">
//           Search
//         </button>
//       </div>
//     </div>
//   );
// };

// export default NextRide;


// import React from "react";
// import { AiOutlineClose } from "react-icons/ai";

// const NextRide = ({ onClose }) => {
//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-xl p-6 w-full max-w-lg  relative"> {/* Adjusted max-w and height */}
//         <button
//           className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
//           aria-label="Close"
//           onClick={onClose}
//         >
//           <AiOutlineClose size={24} />
//         </button>

//         <h2 className="text-xl font-semibold text-center text-gray-800 mb-6">
//           Search your next ride
//         </h2>

//         {/* Pickup Date & Time */}
//         <div className="mb-4">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Pickup Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="date"
//                 placeholder="Date"
//                 className="w-full focus:outline-none placeholder-gray-400"
//               />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="time"
//                 placeholder="Time"
//                 className="w-full focus:outline-none placeholder-gray-400"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Dropoff Date & Time */}
//         <div className="mb-6">
//           <label className="text-gray-700 font-medium text-left block mb-2">
//             Dropoff Date & Time
//           </label>
//           <div className="flex space-x-2 mt-2">
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="date"
//                 placeholder="Date"
//                 className="w-full focus:outline-none placeholder-gray-400"
//               />
//             </div>
//             <div className="flex items-center border rounded-lg px-3 py-2 w-full">
//               <input
//                 type="time"
//                 placeholder="Time"
//                 className="w-full focus:outline-none placeholder-gray-400"
//               />
//             </div>
//           </div>
//         </div>

//         <button className="w-full bg-[#FF9630] text-white py-2 rounded-lg font-semibold hover:bg-[#FF9630]">
//           Search
//         </button>
//       </div>
//     </div>
//   );
// };

// export default NextRide;

import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const NextRide = ({ onClose }) => {
  const navigate = useNavigate(); // Initialize navigate

  const handleSearchClick = () => {
    if (window.innerWidth <= 768) {
      // Redirect for mobile devices (<= 768px width)
      navigate("/filter-relevance");
    } else {
      // Optional: Handle other cases for larger screens
      navigate("/accesories-component");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-lg relative">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          aria-label="Close"
          onClick={onClose}
        >
          <AiOutlineClose size={24} />
        </button>

        <h2 className="text-xl font-semibold text-center text-gray-800 mb-6">
          Search your next ride
        </h2>

        {/* Pickup Date & Time */}
        <div className="mb-4">
          <label className="text-gray-700 font-medium text-left block mb-2">
            Pickup Date & Time
          </label>
          <div className="flex space-x-2 mt-2">
            <div className="flex items-center border rounded-lg px-3 py-2 w-full">
              <input
                type="date"
                placeholder="Date"
                className="w-full focus:outline-none placeholder-gray-400"
              />
            </div>
            <div className="flex items-center border rounded-lg px-3 py-2 w-full">
              <input
                type="time"
                placeholder="Time"
                className="w-full focus:outline-none placeholder-gray-400"
              />
            </div>
          </div>
        </div>

        {/* Dropoff Date & Time */}
        <div className="mb-6">
          <label className="text-gray-700 font-medium text-left block mb-2">
            Dropoff Date & Time
          </label>
          <div className="flex space-x-2 mt-2">
            <div className="flex items-center border rounded-lg px-3 py-2 w-full">
              <input
                type="date"
                placeholder="Date"
                className="w-full focus:outline-none placeholder-gray-400"
              />
            </div>
            <div className="flex items-center border rounded-lg px-3 py-2 w-full">
              <input
                type="time"
                placeholder="Time"
                className="w-full focus:outline-none placeholder-gray-400"
              />
            </div>
          </div>
        </div>

        <button
          className="w-full bg-[#FF9630] text-white py-2 rounded-lg font-semibold hover:bg-[#FF9630]"
          onClick={handleSearchClick} // Trigger navigation on click
        >
          Search
        </button>
      </div>
    </div>
  );
};

export default NextRide;
